import { errorDescriptionFromResponse } from '../../utils/error';
import { FindTimeZone, JstzMatchesTzInfo, JstzToTzInfo } from '../../utils/timezone';
import { RRule } from 'rrule';
export default class NewEventController {
  constructor(
    $scope,
    $state,
    $analytics,
    $timeout,
    $q,
    $uibModal,
    EditOrCreateEventService,
    toaster,
    Facebook,
    $rootScope,
    Overlays
  ) {
    'ngInject';

    const { account, user } = $rootScope;

    this.$scope = $scope;
    this.$rootScope = $rootScope;
    this.$state = $state;
    this.$analytics = $analytics;
    this.$q = $q;
    this.$uibModal = $uibModal;
    this.EditOrCreateEventService = EditOrCreateEventService;
    this.toaster = toaster;
    this.fb = Facebook;
    this.Overlays = Overlays;
    this.showFeatured = account.extra_features.featured_broadcasts;

    const { boxcasterId, streamSource, staticRtmpId, sourceBroadcastId } = this.$state.params;

    if (streamSource == 'app') {
      // Make sure to always allow broadcaster app, even if they haven't had the automatic
      // preference feature flag applied yet.
      if (!account.usage_flags.broadcaster_app) {
        let usage_flags = (account.usage_flags || '').split(/\s+/);
        usage_flags.push('broadcaster_app');
        account.usage_flags = usage_flags.sort().join(' ');
      }
    }

    this.showSocial = true;

    this.MAX_RECURRING_EVENTS = MAX_RECURRING_EVENTS;

    this.wizard = false;
    if (localStorage.getItem('wizard')) {
      this.wizard = parseInt(localStorage.getItem('wizard'), 10) == 1;
    }

    let cloneId = null,
      clone = false;

    $scope.$watch(
      () => $scope.form.$pristine,
      (isPristine) => {
        this.$state.current.confirmOnExit = !isPristine;
      }
    );

    const accountTimezone__tzInfo = $rootScope.account.time_zone;
    const currentTimezone__jstz = FindTimeZone();
    this.currentTimezoneValue = currentTimezone__jstz;
    this.currentTimezone = JstzToTzInfo(currentTimezone__jstz);
    this.timezoneMatchesAccount = JstzMatchesTzInfo(currentTimezone__jstz, accountTimezone__tzInfo);

    this.recurring = {
      enabled: false,
      pattern: 'week',
      end: 'after',
      endCount: 10,
      endDate: moment().add(30, 'day').toDate(),
      onDays: [1, 2, 3, 4, 5],
    };
    this.toggleOnDays = (i) => {
      var idx = this.recurring.onDays.indexOf(i);
      if (idx > -1) {
        this.recurring.onDays.splice(idx, 1);
      } else {
        this.recurring.onDays.push(i);
      }
    };

    this.getPatternLastRecurringDate = () => {
      const count = this.recurring.endCount > 1 ? this.recurring.endCount : 1;
      let recurrence;

      switch (this.recurring.pattern) {
        case `day`:
          recurrence = new RRule({
            freq: RRule.DAILY,
            count,
            wkst: RRule.SU,
            dtstart: this.service.startDate, // eg. new Date(Date.UTC(2012, 1, 1, 10, 30))
          });
          break;
        case `week`:
          recurrence = new RRule({
            freq: RRule.WEEKLY,
            count,
            wkst: RRule.SU,
            dtstart: this.service.startDate,
          });
          break;
        case `weekbyday`:
          recurrence = new RRule({
            freq: RRule.WEEKLY,
            byweekday: this.recurring.onDays,
            count,
            wkst: RRule.SU,
            dtstart: this.service.startDate,
          });
          break;
        case `month`:
          let opts = {
            freq: RRule.MONTHLY,
            count,
            wkst: RRule.SU,
            dtstart: this.service.startDate,
          };

          // if recurrence falls within last dates of a month, accomodate
          // 31st each month with a fallback to the last valid day in that month:
          if (moment(this.service.startDate).date() === 31) {
            opts.bymonthday = [28, 29, 30, 31];
            opts.bysetpos = -1;
          } else if (moment(this.service.startDate).date() === 30) {
            // 30th each month with a fall back to the 28th or 29th (in leap years) in February
            opts.bymonthday = [28, 29, 30];
            opts.bysetpos = -1;
          } else if (moment(this.service.startDate).date() === 29) {
            // 29th each month with a fall back to the 28th in February in non-leap years
            opts.bymonthday = [28, 29];
            opts.bysetpos = -1;
          }

          recurrence = new RRule(opts);
          break;
        default:
          console.log(`unknown pattern: ${this.recurring.pattern}`);
          return moment(this.service.startDate);
      }

      const recurringDates = recurrence.all();
      const lastRecurringDate = recurringDates[recurringDates.length - 1];
      return moment(lastRecurringDate);
    };

    this.isRecurringPatternValid = () => {
      // pattern is valid if this is not a simulated live rebroadcast
      if (!this.service.sourceBroadcast) {
        return true;
      }

      if (this.service.account.storage_policy !== `auto-delete`) {
        return true;
      }

      const broadcastExpiration = moment(this.service.sourceBroadcast.storage_expires_at);

      if (this.recurring.end === 'on') {
        return moment(this.recurring.endDate).isBefore(broadcastExpiration);
      }

      const lastRecurringDate = this.getPatternLastRecurringDate();
      return lastRecurringDate.isBefore(broadcastExpiration);
    };

    if (this.$state.params.cloneId) {
      cloneId = this.$state.params.cloneId;
      clone = true;
      this.scheduleAgain = true;
      this.$analytics.eventTrack(`new-event-${this.wizard ? 'wizard' : 'quick'}`, {
        category: 'open',
        label: 'clone',
      });
    } else {
      this.scheduleAgain = false;
      this.$analytics.eventTrack(`new-event-${this.wizard ? 'wizard' : 'quick'}`, {
        category: 'open',
        label: '',
      });
    }

    this.service = EditOrCreateEventService.getInstance();
    this.service.initBroadcast(cloneId, clone);
    this.service.initScope($scope);

    if (boxcasterId) {
      this.service.broadcast.boxcaster_id = boxcasterId;
    } else if (staticRtmpId) {
      this.service.broadcast.boxcaster_id = `stream_source:rtmp:${staticRtmpId}`;
    } else if (streamSource) {
      this.service.broadcast.boxcaster_id = `stream_source:${streamSource}`;
      if (streamSource === 'recording' && sourceBroadcastId) {
        this.service.fromBroadcast(sourceBroadcastId);
      }
    }

    this.maxValidStep = 1;
    this.step = 1;
    this.showError = false;

    if (this.service.broadcast.$promise) {
      this.service.broadcast.$promise.then(() => {
        this.fb.init();
      });
    } else {
      $timeout(() => this.fb.init(), 0);
    }

    $q.all([this.service.boxcasters.$promise, this.service.staticRTMPs.$promise]).then(() => {
      if (!this.service.broadcast.boxcaster_id) {
        this.service.chooseDefaultSourceForNewBroadcast();
      }
    });

    if (account.feature_flags.overlays && user.can('update', 'broadcast/*:metadata/overlays')) {
      this.loadOverlays();
    }

    this.loadingPromises = [this.service.boxcasters.$promise, this.service.channels.$promise];

    // Auto-focus on page load
    setTimeout(() => $('#eventName').focus(), 0);
  }

  loadOverlays() {
    const { Overlays, toaster } = this;
    Overlays.loadOverlaysForPage(1)
      .then((result) => {
        this.overlays = result.uploads;
      })
      .catch((err) => {
        toaster.pop('info', 'Unable to load overlay image gallery.');
      });
  }

  selectOverlay(upload) {
    var { Overlays, toaster } = this;
    const { broadcast } = this.service;
    this.processingOverlay = true;
    Overlays.prepareUploadForOverlay(upload)
      .then((overlay) => {
        broadcast.metadata = broadcast.metadata || {};
        broadcast.metadata.overlays = [overlay];
        this.processingOverlay = false;
      })
      .catch((err) => {
        console.error(err);
        toaster.pop('warn', 'Unable to select overlay image.');
        this.processingOverlay = false;
      });
  }

  loginFacebook() {
    this.fb.login().then(() => {
      this.service.initializeEmptyFacebookAccountIDs();
    });
  }

  logoutFacebook() {
    this.fb.logout().then(() => this.fb.init());
  }

  toggleEntryMode() {
    this.wizard = !this.wizard;
    localStorage.setItem('wizard', this.wizard ? '1' : '0');
    this.$analytics.eventTrack(`new-event-${this.wizard ? 'wizard' : 'quick'}`, {
      category: 'toggle-entry-mode',
      label: '',
    });
  }

  validateCurrentTab() {
    this.service.errors = [];

    if (this.step == 1) {
      if (!this.service.validateOverview()) {
        this.$analytics.eventTrack(`new-event-${this.wizard ? 'wizard' : 'quick'}`, {
          category: 'validate-error',
          label: 'overview',
        });
        return false;
      }
    }

    if (this.step == 2) {
      if (!this.service.validateSchedule()) {
        this.$analytics.eventTrack(`new-event-${this.wizard ? 'wizard' : 'quick'}`, {
          category: 'validate-error',
          label: 'schedule',
        });
        return false;
      }
      if (
        this.recurring.enabled &&
        this.recurring.end == 'after' &&
        this.recurring.endCount > MAX_RECURRING_EVENTS
      ) {
        this.$analytics.eventTrack(`new-event-${this.wizard ? 'wizard' : 'quick'}`, {
          category: 'validate-error',
          label: 'recurring',
        });
        return false;
      }
    }

    if (this.step == 3) {
      if (!this.service.validateScoreboard()) {
        this.$analytics.eventTrack(`new-event-${this.wizard ? 'wizard' : 'quick'}`, {
          category: 'validate-error',
          label: 'scoreboard',
        });
        return false;
      }
    }

    if (this.step == 4) {
      if (!this.service.validatePublish()) {
        this.$analytics.eventTrack(`new-event-${this.wizard ? 'wizard' : 'quick'}`, {
          category: 'validate-error',
          label: 'publish',
        });
        return false;
      }
    }

    return true;
  }

  prevTab() {
    this.step -= 1;
    // skip scoreboard tab if not available
    if (!this.service.showAnyScoreboards && this.step == 3) {
      this.step -= 1;
    }
    if (this.step < 1) {
      this.step = 1;
    }
  }

  nextTab() {
    if (!this.validateCurrentTab()) {
      this.showError = true;
      return;
    }

    this.showError = false;
    this.step += 1;

    // skip scoreboard tab if not available
    if (!this.service.showAnyScoreboards && this.step == 3) {
      this.step += 1;
    }
    if (this.step > 5) {
      this.step = 5;
    }

    // keep track of how far they've gone successfully (in case they go back)
    this.maxValidStep = Math.max(this.step, this.maxValidStep);
  }

  selectTab(idx) {
    if (this.maxValidStep > idx - 1) {
      this.step = idx;
    }
  }

  addSimulcastDestination(d, params) {
    return this.service.addSimulcastDestination(d, params);
  }

  removeSimulcastDestination(d) {
    return this.service.removeSimulcastDestination(d);
  }

  submit() {
    const { $uibModal } = this;

    const actuallySubmit = () => {
      this.showError = false;
      this.submitting = true;

      if (this.recurring.enabled) {
        this.service.broadcast.recurrence = {
          interval: this.recurring.pattern,
          on_days: this.recurring.onDays,
          max: MAX_RECURRING_EVENTS,
          time_zone: this.currentTimezoneValue,
        };
        if (this.recurring.end == 'after') {
          this.service.broadcast.recurrence.end_after_count = this.recurring.endCount || 1;
        } else if (this.recurring.end == 'on') {
          this.service.broadcast.recurrence.end_on_date = this.recurring.endDate;
        }
      }

      this.service
        .saveChanges()
        .then((broadcast) => {
          this.submitting = false;

          this.$analytics.eventTrack(`new-event-${this.wizard ? 'wizard' : 'quick'}`, {
            category: 'saved',
            label: '',
          });

          if (this.scheduleAgain) {
            console.log('Success! Copying this and doing another...', broadcast);
            this.toaster.pop({
              type: 'success',
              title: 'Successfully scheduled broadcast',
              body: 'You can now schedule another like it. The defaults have been filled in.',
            });
            this.$state.current.confirmOnExit = false;
            this.$state.go('new-event', { cloneId: broadcast.id }, { reload: true });
          } else {
            console.log('Success! Redirecting to view event...', broadcast);
            this.toaster.pop({
              type: 'success',
              title: 'Successfully scheduled broadcast',
            });
            this.$state.current.confirmOnExit = false;
            this.$state.go('events.detail', { id: broadcast.id });
          }

          this.$rootScope.$emit('sm-schedule-step', 2);
        })
        .catch((error) => {
          this.submitting = false;
          let errorDetails = errorDescriptionFromResponse(error);
          if (errorDetails == 'invalid') {
            this.showError = true;
            $('html, body').animate({ scrollTop: 0 });
          } else {
            console.error(error);
            alert(
              'Unable to save broadcast. Please check your fields and try again.\n\n' + errorDetails
            );
          }
          this.$analytics.eventTrack(`new-event-${this.wizard ? 'wizard' : 'quick'}`, {
            category: 'error',
            label: errorDetails,
          });
        });
    }; //end actuallySubmit

    if (this.service.conflictingEvents.length > 0) {
      const { conflictingEvents } = this.service;
      $uibModal
        .open({
          template: require('../events/modal-conflicting-events.html'),
          controller: function ($scope, $uibModalInstance) {
            'ngInject';
            $scope.conflictingEvents = conflictingEvents;
            $scope.ok = (result) => $uibModalInstance.close(result);
            $scope.close = () => $uibModalInstance.dismiss('cancel');
          },
        })
        .result.then(actuallySubmit);
    } else {
      actuallySubmit();
    }
  }
}



// WEBPACK FOOTER //
// ./app/pages/new-event/new-event-controller.js